import { useState } from "react";
import api, { apiError } from "@/lib/api";
import { Check } from "lucide-react";
import { toast } from "sonner";

export const ConfirmarEnvio = ({ origemId, onDone, testid }) => {
  const [busy, setBusy] = useState(false);
  const confirmar = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/encomendas/confirmar-envio", { origem_id: origemId });
      toast.success(data.enviadas.length ? `Encomenda(s) #${data.enviadas.join(", #")} marcada(s) como enviada(s).` : "Sem encomendas por enviar.");
      onDone && onDone();
    } catch (err) { toast.error(apiError(err)); }
    setBusy(false);
  };
  return (
    <button onClick={confirmar} disabled={busy} title="Confirmar encomenda efetuada" data-testid={testid}
      className="shrink-0 self-center h-6 w-6 rounded border-2 border-emerald-500 bg-white flex items-center justify-center text-emerald-600 hover:bg-emerald-50 disabled:opacity-50 transition-colors group">
      <Check size={13} strokeWidth={3} className={busy ? "opacity-100" : "opacity-0 group-hover:opacity-100"} />
    </button>
  );
};
